import { useDisclosure } from '@mantine/hooks';
import { useState } from 'react';
import { useEvent } from 'react-use';

import type { EventId, EventPropsMap } from '../constants/MODAL_EVENT_ID';

type props<T extends EventId> = {
  eventId: T;
  initialState?: boolean;
};

export const useForAntManModalDisclosure = <T extends EventId>({
  eventId,
  initialState = false,
}: props<T>) => {
  type CustomEventProps = EventPropsMap[props<T>['eventId']];
  const [isOpened, handler] = useDisclosure(initialState);
  const [eventProps, setEventProps] = useState<CustomEventProps>();

  useEvent(
    eventId,
    (e: CustomEventInit<CustomEventProps>) => {
      setEventProps(() => {
        handler.open();

        return e.detail;
      });
    },
    window
  );

  return [isOpened, handler, eventProps] as const;
};
